// Global toast de-duplication.
//
// Dozens of components surface API failures with a generic `toast.error(res?.message || "…")`. When a
// STAFF (e.g. a receptionist) opens the dashboard, several feature-gated widgets each 403 with the
// SAME backend message — "You don't have access to this feature. Ask your gym owner to grant it." —
// and react-toastify used to STACK one red toast per call (the 2-3 identical toasts in the bug report).
//
// Fix: give every STRING toast a content-derived toastId (unless the caller already set one).
// react-toastify treats a duplicate toastId as "already showing" and collapses it, so N identical
// messages become ONE toast. Purely additive:
//   • a caller that passes its own toastId still wins,
//   • non-string (React-node) content is never touched,
//   • once the single toast auto-closes its id frees, so a later identical message can show again.
import { toast } from "react-toastify";

// Pure: the options a `kind` toast with `content` should carry so identical messages collapse to one.
// A string message gets a content-derived toastId (unless the caller set one); non-string content and
// caller-supplied toastIds are left untouched.
export function dedupOpts(kind, content, opts) {
  const o = opts || {};
  if (typeof content === "string" && o.toastId == null) return { ...o, toastId: `${kind}:${content}` };
  return o;
}

let installed = false;

export function installToastDedup(target = toast) {
  if (installed || !target) return false;
  installed = true;
  ["error", "success", "info", "warn", "warning"].forEach((k) => {
    const orig = typeof target[k] === "function" ? target[k].bind(target) : null;
    if (!orig) return;
    target[k] = (content, opts) => orig(content, dedupOpts(k, content, opts));
  });
  return true;
}
